module.exports = __webpack_public_path__ + "img/Frame3.8edde9ba.svg";